export default "__VITE_ASSET__BieDAbIO__"